// Custom header JS here.

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".header-loaded")) {
    console.log("Header JS already loaded");
    return;
  }

  // add header-loaded class to body
  document.body.classList.add("header-loaded");

  console.log("Header JS loaded");
  var hamburgerMenu = document.getElementById("hamburger"); // Hamburger menu UI.
  var siteNavigation = document.getElementById("main-nav"); // Main navigation wrapper.
  var subMenuItems = document.querySelectorAll(".has-submenu");

  // Add current-menu-item class to parent menu items
  var parentItems = document.querySelectorAll("#mega-header .has-submenu");

  parentItems.forEach(function (parentItem) {
    var childItems = parentItem.querySelectorAll(".submenu li");

    childItems.forEach(function (childItem) {
      if (childItem.classList.contains("current-menu-item")) {
        parentItem.classList.add("current-menu-item");
      }
    });
  });

  // Submenu functionality
  subMenuItems.forEach(function (subMenuItem) {
    var subMenuLink = subMenuItem.querySelector("a");
    var submenu = subMenuItem.querySelector(".submenu");

    // Function to toggle submenu active class
    function toggleSubMenu(active) {
      if (active) {
        submenu.classList.add("active");
      } else {
        submenu.classList.remove("active");
      }

      //   submenu.classList.toggle("active");
      subMenuLink.setAttribute(
        "aria-expanded",
        submenu.classList.contains("active")
      );
      submenu.setAttribute(
        "aria-hidden",
        !submenu.classList.contains("active")
      );
    }

    // Function to handle mouse enter and mouse leave events
    function handleMouseEnter() {
      //   console.log("mouseenter");
      toggleSubMenu(true);
    }

    function handleMouseLeave() {
      //   console.log("mouseleave");
      // toggleSubMenu();
      submenu.classList.remove("active");
      subMenuLink.setAttribute("aria-expanded", false);
      submenu.setAttribute("aria-hidden", true);
    }

    // Function to handle click event on mobile devices
    function handleClickEvent(event) {
      event.preventDefault(); // Prevent default link behavior
      toggleSubMenu(!submenu.classList.contains("active"));
    }

    // Function to check viewport width and attach appropriate event listeners
    function checkViewportWidth() {
      if (window.innerWidth <= 1099) {
        subMenuItem.removeEventListener("mouseenter", handleMouseEnter);
        subMenuItem.removeEventListener("mouseleave", handleMouseLeave);
        subMenuLink.addEventListener("click", handleClickEvent);
      } else {
        subMenuItem.addEventListener("mouseenter", handleMouseEnter);
        subMenuItem.addEventListener("mouseleave", handleMouseLeave);
        subMenuLink.removeEventListener("click", handleClickEvent);
      }
    }

    // Initial check on page load
    checkViewportWidth();

    // Re-check on window resize
    window.addEventListener("resize", checkViewportWidth);
  });

  // Open and close the mobile menu.
  if (hamburgerMenu) {
    hamburgerMenu.addEventListener("click", function () {
      //   console.log("hamburger click");
      if (!hamburgerMenu.classList.contains("active")) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      hamburgerMenu.classList.toggle("active");
      siteNavigation.classList.toggle("active");
    });
  }

  /* Supernav Search */
  // var searchIcon = document.getElementById("search-icon");
  // var searchBox = document.getElementById("search-box");

  // searchIcon.addEventListener("click", function (event) {
  //   event.preventDefault(); // Prevents the link from navigating
  //   if (searchBox.style.display === "none" || searchBox.style.display === "") {
  //     searchBox.style.display = "block"; // Show the search box
  //   } else {
  //     searchBox.style.display = "none"; // Hide the search box
  //   }
  // });

  // // Optionally, hide the search box if clicking outside of it
  // document.addEventListener("click", function (event) {
  //   if (
  //     !searchIcon.contains(event.target) &&
  //     !searchBox.contains(event.target)
  //   ) {
  //     searchBox.style.display = "none";
  //   }
  // });
});


